<template>
  <div style="margin-top: 20px">
    <el-row class="table">
      <el-col :span="24">
        <el-table
          :data="tableData.classVOs"
          size="medium"
          border
          :header-cell-style="{ background: '#f9f9f9' }"
          :cell-style="cellStyle"
          :cell-class-name="cellClass"
          :row-style="{ height: '40px' }"
          @cell-mouse-enter="hoverCell"
          @cell-mouse-leave="leaveCell"
        >
          <el-table-column prop="className" label="班级名称"></el-table-column>
          <el-table-column
            prop="studentNumber"
            label="班级人数"
          ></el-table-column>
          <el-table-column
            label="班主任"
            prop="classTeacher"
            min-width="110"
            class="classTeacher"
          >
            <template v-if="scope.row.classTeachersArr" slot-scope="scope">
              <div class="select class-teacher-select">
                <el-tooltip
                  placement="top"
                  v-if="
                    scope.row.classTeachers &&
                      scope.row.classTeachers.length > 0
                  "
                >
                  <div slot="content">
                    <span
                      v-for="(item, index) in scope.row.classTeachers"
                      :key="item.name"
                    >
                      {{ item.name }}
                      <span v-if="index < scope.row.classTeachers.length - 1"
                        >、</span
                      >
                    </span>
                  </div>
                  <span
                    style="font-size: 13px"
                    @click="
                      val =>
                        changeClassTeacher(scope.row, scope.row.classTeachers)
                    "
                    >请选择</span
                  >
                </el-tooltip>
                <span
                  v-else
                  style="font-size: 13px"
                  @click="
                    val =>
                      changeClassTeacher(scope.row, scope.row.classTeachers)
                  "
                  >请选择</span
                >
              </div>
              <div class="class-teacher-name">
                <span
                  v-if="
                    scope.row.classTeachers &&
                      scope.row.classTeachers.length === 0
                  "
                  >-</span
                >
                <span v-else>
                  <span class="teacher-span">
                    <span
                      v-for="(item, index) in scope.row.classTeachers"
                      :key="item.name"
                    >
                      {{ item.name }}
                      <span v-if="index < scope.row.classTeachers.length - 1"
                        >、</span
                      >
                    </span>
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="任课教师" align="center">
            <el-table-column
              v-for="subject in tableData.subjectPair"
              :key="subject.value"
              :prop="subject.value.toString()"
              :label="subject.name"
            >
              <template slot-scope="scope">
                <div
                  :class="
                    scope.row[subject.value.toString()].edit ? 'hidenSpan' : ''
                  "
                >
                  <span
                    v-if="
                      scope.row[subject.value.toString()].teacherArr.length ===
                        0
                    "
                    >-</span
                  >
                  <span v-else>
                    <span class="teacher-span">
                      <span
                        v-for="(item, index) in scope.row[
                          subject.value.toString()
                        ].teacherArr"
                        :key="item.value"
                      >
                        {{ item.name }}
                        <span
                          v-if="
                            index <
                              scope.row[subject.value.toString()].teacherArr
                                .length -
                                1
                          "
                          >、</span
                        >
                      </span>
                    </span>
                  </span>
                </div>
                <div
                  v-if="scope.row[subject.value.toString()].edit"
                  class="select"
                >
                  <el-tooltip
                    v-if="
                      scope.row[subject.value.toString()].teacherArr &&
                        scope.row[subject.value.toString()].teacherArr.length >
                          0
                    "
                    placement="top"
                  >
                    <div slot="content">
                      <span
                        v-for="(item, index) in scope.row[
                          subject.value.toString()
                        ].teacherArr"
                        :key="item.value"
                      >
                        {{ item.name }}
                        <span
                          v-if="
                            index <
                              scope.row[subject.value.toString()].teacherArr
                                .length -
                                1
                          "
                          >、</span
                        >
                      </span>
                    </div>
                    <span
                      class="teacher-span"
                      style="font-size: 13px"
                      @click="
                        editTeacher(
                          scope.row,
                          scope.row[subject.value.toString()]
                        )
                      "
                      >请选择</span
                    >
                  </el-tooltip>
                  <span
                    v-else
                    class="teacher-span"
                    style="font-size: 13px"
                    @click="
                      editTeacher(
                        scope.row,
                        scope.row[subject.value.toString()]
                      )
                    "
                    >请选择</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="$regional.disableCRUD"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <suject-teacher-editor
      :visible.sync="editorVisible"
      :identify="teacherInfo"
      :teacherGrade="teacherGrade"
      :classInfo="classInfo"
      :availableTeahcers="availableTeahcers"
      :isClassTeacher="isClassTeacher"
      :teacherChange="teacherChange"
      @edit-result="initData"
    ></suject-teacher-editor>

    <class-edit-box
      :visible.sync="classEditorVisible"
      :identify="classInfo"
      :grades="gradesInfo"
      @edit-result="initData"
    ></class-edit-box>
  </div>
</template>

<script>
import _ from 'lodash'
import SubjectTeacherEditor from '@/components/school-admin/affair/SubjectTeacherEditor'
import ClassEditor from '@/components/school-admin/affair/ClassEditor'
export default {
  props: ['junior', 'gradesInfo'],

  components: {
    'suject-teacher-editor': SubjectTeacherEditor,
    'class-edit-box': ClassEditor
  },

  data() {
    return {
      tableData: [],
      editorVisible: false,
      teacherInfo: {},
      classEditorVisible: false,
      classInfo: {},
      teacherGrade: '',
      availableTeahcers: null,
      isClassTeacher: false
    }
  },

  watch: {},

  computed: {},

  mounted() {
    this.$xhrGet(`/acc/teachers/available`, { grade: this.junior }).then(rs => {
      if (rs.data) {
        this.$set(this, 'availableTeahcers', rs.data)
      } else {
        this.$message.error('当前学校暂无可设置任课的教师')
      }
    })
    this.initData()
  },

  methods: {
    initData() {
      this.$xhrGet(`/acc/classes`, { grade: this.junior }).then(rs => {
        let res = rs.data
        for (let index = 0; index < res.classVOs.length; index++) {
          let element = res.classVOs[index]
          this.$set(
            element,
            'classTeachersArr',
            _.map(element.classTeachers, 'value')
          )
          if (element.subjectTeachers) {
            for (
              let innerIndex = 0;
              innerIndex < element.subjectTeachers.length;
              innerIndex++
            ) {
              let innerElement = element.subjectTeachers[innerIndex]
              let subject = _.filter(res.subjectPair, {
                value: innerElement.t1
              })[0]
              this.$set(element, 'subject', {})
              this.$set(element, innerElement.t1, {})
              this.$set(element[innerElement.t1], 'teacherArr', innerElement.t2)
              this.$set(element[innerElement.t1], 'subjectName', subject.name)
              this.$set(
                element[innerElement.t1],
                'subjectValue',
                innerElement.t1
              )
            }
          }
        }
        this.tableData = res
      })
    },

    teacherChange(teachers, classId) {
      return new Promise((resolve, reject) => {
        this.$xhrPost(`/acc/classes/${classId}/class_teacher`, {
          teacherIds: teachers
        })
          .then(rs => {
            if (rs.code === 'SUCCESS') {
              this.$message.success('操作成功')
              this.initData()
            }
            resolve()
          })
          .catch(reject)
      })
    },

    changeClassTeacher(row, classTeachers) {
      this.$set(this, 'teacherInfo', row)
      this.$set(this.teacherInfo, 'teacherArr', classTeachers)
      this.isClassTeacher = true
      this.editorVisible = true
    },

    handleAdd() {
      this.classInfo = {}
      this.classEditorVisible = true
    },

    hoverCell(row, column, cell, event) {
      if (
        column.property !== 'className' &&
        column.property !== 'studentNumber' &&
        column.property
      ) {
        if (row[Number(column.property)]) {
          this.$set(row[Number(column.property)], 'edit', true)
        }
      }
    },

    leaveCell(row, column, cell, event) {
      if (
        column.property !== 'className' &&
        column.property !== 'studentNumber' &&
        column.property
      ) {
        if (row[Number(column.property)]) {
          this.$set(row[Number(column.property)], 'edit', false)
        }
      }
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (row[Number(column.property)] && row[Number(column.property)].edit) {
        return 'background: #DCDFE6;'
      }
    },

    cellClass({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'classTeacher') {
        return 'classTeacher'
      }
    },

    editTeacher(classInfo, subject) {
      this.isClassTeacher = false
      this.classInfo = classInfo
      this.teacherInfo = subject
      this.teacherGrade = this.junior
      this.editorVisible = true
    },

    handleEdit(index, row) {
      this.classEditorVisible = true
      this.classInfo = row
    },

    handleDelete(index, row) {
      if (row.studentNumber !== 0) {
        this.$message.error('当前班级内存在学生用户，无法删除')
        return false
      }
      this.$xhrDelete(`/acc/classes/${row.classId}`).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initData()
        } else if (rs.code === 'class_not_empty') {
          this.$message.error('当前班级内存在学生用户，无法删除')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 10px;
}
.table /deep/ .el-input__inner {
  border: none;
}
.hidenSpan {
  opacity: 0.6;
}
.select {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  color: var(--theme-color);
}
.class-teacher-name {
  &:hover {
    opacity: 0.6;
  }
}
.class-teacher-select {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  opacity: 0;
  &:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.1);
    & + .class-teacher-name {
      color: rgba(0, 0, 0, 0.3);
    }
  }
}
/deep/ tbody tr td {
  padding: 0 !important;
}
/deep/ .el-tag__close.el-icon-close {
  display: none;
}
/deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teacher-span {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-select-dropdown__item /deep/ span {
  display: inline-block;
  width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/ClassTabContent.vue